export const siteInfo = {
  name: "国模白露写真馆",
  title: "国模白露 - 专业写真摄影作品欣赏与风格解析",
  description: "国模白露是国内知名专业模特，以其独特气质与多变造型深受摄影爱好者关注。本页汇集白露写真风格解析、拍摄技巧参考及模特职业发展历程，为摄影师与模特爱好者提供专业内容参考。",
  keywords: "国模白露,白露模特,国模写真,专业模特欣赏,模特风格解析,写真摄影参考,国内人像模特",
  url: "https://bailu-model.com",
  brandIntro: "国模白露写真馆是国内领先的专业模特写真摄影作品分享平台。我们致力于为摄影爱好者和模特行业关注者提供高质量的白露写真作品、风格解析与拍摄技巧参考。白露以其独特的气质和多样的造型风格，在国内模特界享有盛誉。",
  reputation: [
    { text: "作品质量高，风格多样，每次浏览都能获得新的摄影灵感。", author: "摄影师张明", role: "人像摄影师" },
    { text: "白露的专业表现力令人印象深刻，是模特行业的学习标杆。", author: "李婷", role: "时尚编辑" },
    { text: "网站内容丰富专业，分类清晰，找参考资料非常方便。", author: "王浩然", role: "摄影爱好者" },
    { text: "从新手到专业，这里的内容覆盖了各个层次的摄影学习需求。", author: "陈思远", role: "自由摄影师" },
  ],
  contact: {
    email: "contact@bailu-model.com",
    wechat: "bailu_model_official",
    weibo: "@国模白露写真馆",
    address: "北京市朝阳区建国路88号",
  },
  stats: [
    { label: "作品数量", value: "500+" },
    { label: "风格分类", value: "12" },
    { label: "合作摄影师", value: "80+" },
    { label: "年度访问", value: "200万+" },
  ],
};